// components/admin/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Get token from localStorage
  const token = localStorage.getItem('admin_token');
  
  console.log('PrivateRoute: Token exists?', !!token);
  
  // SIMPLE CHECK: If token exists, allow access
  // This matches your old working setup
  if (!token) {
    console.log('No token, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // Token exists, allow access
  return children;
};

export default PrivateRoute;